import {Link} from "react-router-dom";
import {useState} from 'react';
import {sendEventToGA} from "./../utils.js";


export function LearnCard(props) {

    // eslint-disable-next-line
    const [ article, setArticle] = useState(props.title);

    const handleError = (event) => {
        event.target.src = "https://via.placeholder.com/200?text=\n ";
    };

    const handleClick = () => {
        sendEventToGA(`article_card__${article}__button`, 'articles' , article);
    };

    return (
        <div className="cardContainer">
            <div className= {props.wide ? "learnCardWide" : "learnCard"}>
              <div>
                <a href={props.link} target="_blank" rel="noreferrer" onClick={handleClick}>
                  <div className="learnPhoto">
                    <img
                      src={props.cardImage || "https://via.placeholder.com/200?text=\n "}
                      className={
                        props.wide
                          ? "learnCardPhotoWide"
                          : `learnCardPhoto${props.slug ? ` learnCardPhoto--${props.slug}` : ""}`
                      }
                      alt= "card"
                      onError={handleError} />
                  </div>
                </a>
                <div className="learnCardBody">
                  <div>
                    <div className="learnCardTitle">
                      <a href={props.link} target="_blank" rel="noreferrer"><b>{props.title}</b></a>
                    </div>
                    <div className="learnCardDescription">
                      {props.body}
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
    );
}
